import { useMemo } from 'react';
import get from 'lodash/get';
import { useAppSelector } from '../../../hooks/useAppStore';
import { getAuthenticateUser } from '../../../store/authenticate/selectors';
import { getManagerPermissions } from '../../../store/settings/selectors';
import { usePermissions } from '../../../hooks/useCommon';

export function useSheetsPermissions() {
  const { personnel } = useAppSelector(getAuthenticateUser);
  const settings = useAppSelector(getManagerPermissions);
  const { permissions: localPermissions } = usePermissions();

  const permissions = useMemo(() => {
    const isManager = personnel.permissionLevel === 'Manager';

    // Sheets management and viewing permissions
    const canViewSheets = get(settings, 'visibility.sheets.view');
    const canManageSheets = get(settings, 'actions.sheets.manage');
    const canViewSalaryData = get(settings, 'visibility.sheets.salaryData');

    return {
      isAllowManage: localPermissions.isAdmin
        || (isManager && canViewSheets && canManageSheets),
      isAllowViewSalaryData: localPermissions.isAdmin
        || (isManager && canViewSheets && canViewSalaryData),
    };
  }, [personnel.permissionLevel, settings, localPermissions]);

  return {
    permissions,
  };
}
